import Api from '@/services/Index';

const getModelList = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/system/model-list');
}

const getModelColumnList = async (model) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/system/model-column-list/' + model);
}

const excelExport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/system/excel-export', formData, {responseType: 'arraybuffer'});
}

export default {
    getModelList,
    getModelColumnList,
    excelExport
}
